
import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, effect, ElementRef, inject, input, InputSignal, viewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DetailsButtonComponent } from '../../layouts/details-button/details-button.component';
import QRCode from "qrcode";
import Swal from'sweetalert2';
import { ToolsService } from 'src/app/services/tools.service';
import Swiper from 'swiper';
import SwiperCore from 'swiper';
import { FreeMode, Mousewheel } from 'swiper';
import { MatTooltip } from '@angular/material/tooltip';

SwiperCore.use([FreeMode, Mousewheel]);

@Component({
    selector: 'header-details',
    imports: [
        CommonModule, 
        TranslateModule,
        DetailsButtonComponent,
        MatTooltip
    ],
    standalone: true,
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class HeaderDetailsComponent {
    public swiperRef = viewChild<ElementRef>('swiper');
  
    public id: InputSignal<number> = input.required<number>();
    public type: InputSignal<string> = input.required<string>();
    public name: InputSignal<any> = input.required<any>();
    public duration: InputSignal<any> = input<any>();
    public accessibilityList: InputSignal<any[]> = input<any[]>();
    
    public translate = inject(TranslateService);
    public toolsService = inject(ToolsService);
    
    private _swiperInstance!: Swiper;
    public mockAccesibilityList: any[];
    private qr: any;
    
    setSWiper = effect(() => {
      const swiperEl = this.swiperRef()?.nativeElement;
      if(!swiperEl) return;

      const swiperConfig = {
        slidesPerView: "auto" as const,
        spaceBetween: 8,
        mousewheel: true
      };
      
      this._swiperInstance = new Swiper(swiperEl, swiperConfig);
    }, { allowSignalWrites: true })

    async handleClick() {
      const currentUrl = window.location.href;
      this.makeQRCode(currentUrl);
      const textQR = this.translate.instant('Llévatelo a tu móvil');
      Swal.fire({
        html:  `
        <div class="qr-container">
            <span class="qr-text">${textQR}</span>
            <img draggable="false" class="qr-details-image" src="${this.qr}" >
        </div>
        `,
        showCancelButton: false,
        showConfirmButton: false,
        timer: 10000,
        timerProgressBar: true,
        width: '250px'
      })
    }

    makeQRCode(url) {
      const qrcode = QRCode;
      const self = this;
      const opts = { errorCorrectionLevel: 'H' }
      qrcode.toDataURL(url, opts, function (err, url) { self.qr = url });
    }


}